import * as React from 'react'
import { View } from 'react-native'
import styles from './styles'

export function ProgressBar({
  currentValue,
  targetValue,
}: {
  currentValue: number
  targetValue: number
}) {
  const progress = Math.min(currentValue / targetValue, 1)
  return targetValue === 0 ? null : (
    <View style={styles.progressBar}>
      <View
        style={[styles.innerProgressBar, { width: `${progress * 100}%` }]}
      />
    </View>
  )
}
